export default __webpack_public_path__ + "static/image0-63fe79a2e43e55c56f528aae27c6ed25.png";